import {Dce, DceComponent, DceHTMLElement} from "dce-engine";

interface TocProps {
    targetSelector: string;
}

@Dce("Toc")
export default class AlertButton extends DceComponent<TocProps> {

    private items: Array<HTMLElement[]> = [];
    private offset: number = 120;

    constructor(elem: DceHTMLElement, props: TocProps) {
        super(elem, props);

        let ul = document.createElement('ul');

        let i = 0;

        elem.querySelectorAll('h2, h3').forEach(h => {

            console.log(h);

            i++;

            h.setAttribute('id', 'toc-' + i++);
            h.style.scrollMarginTop = '80px';

            let li = document.createElement('li');

            let a = document.createElement('a');

            if(h.tagName.toLowerCase() == 'h3'){
                a.classList.add('level-3');
            }

            a.innerHTML = h.innerHTML;
            li.append(a);
            ul.append(li);

            a.href = '#' + h.getAttribute('id');

            a.addEventListener('click', e => {
                this.update();
            })

            this.items.push(
                [h as HTMLElement, a]
            );
        })

        document.querySelector(props.targetSelector).append(ul);

        const observer = new IntersectionObserver(() => this.update(), {
            rootMargin: `-${this.offset}px 0px -100% 0px`,
            threshold: 0,
        });

        for (const [heading] of this.items) {
            observer.observe(heading);
        }

    }

    private update() {
        let active = this.items[0][1];

        for (const [heading, toc] of this.items) {
            if (heading.getBoundingClientRect().top <= this.offset) {
                active = toc;
            } else {
                break;
            }
        }

        for (const [, toc] of this.items) {
            toc.classList.toggle('active', toc === active);
        }
    }

}
